"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/account/v1/authop_service.proto (package spwn.account.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthopAccountServiceGetAccountStateResponse = exports.AuthopAccountServiceGetAccountStateRequest = exports.AuthopAccountServiceExchangeOidcLoginCodeResponse = exports.AuthopAccountServiceExchangeOidcLoginCodeRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from message spwn.account.v1.AuthopAccountServiceExchangeOidcLoginCodeRequest
 */
class AuthopAccountServiceExchangeOidcLoginCodeRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * accounts.spwn.jp が auth-op へ渡したコード
         *
         * @generated from field: string code = 1;
         */
        this.code = "";
        /**
         * auth-op が保持する認可リクエストの識別子。コードの発行元と一致するか照合する
         *
         * @generated from field: string oidc_transaction_id = 2;
         */
        this.oidcTransactionId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AuthopAccountServiceExchangeOidcLoginCodeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuthopAccountServiceExchangeOidcLoginCodeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuthopAccountServiceExchangeOidcLoginCodeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AuthopAccountServiceExchangeOidcLoginCodeRequest, a, b);
    }
}
exports.AuthopAccountServiceExchangeOidcLoginCodeRequest = AuthopAccountServiceExchangeOidcLoginCodeRequest;
AuthopAccountServiceExchangeOidcLoginCodeRequest.runtime = protobuf_1.proto3;
AuthopAccountServiceExchangeOidcLoginCodeRequest.typeName = "spwn.account.v1.AuthopAccountServiceExchangeOidcLoginCodeRequest";
AuthopAccountServiceExchangeOidcLoginCodeRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "oidc_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.AuthopAccountServiceExchangeOidcLoginCodeResponse
 */
class AuthopAccountServiceExchangeOidcLoginCodeResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * Firebase の uid。auth-op が sub として使う
         *
         * @generated from field: string uid = 1;
         */
        this.uid = "";
        /**
         * 検証済みのメールアドレス
         *
         * @generated from field: string email = 2;
         */
        this.email = "";
        /**
         * ユーザーが実際に認証した時刻 (UNIX 秒)。auth-op が鮮度の判断に使う
         *
         * @generated from field: int64 auth_time_seconds = 3;
         */
        this.authTimeSeconds = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AuthopAccountServiceExchangeOidcLoginCodeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuthopAccountServiceExchangeOidcLoginCodeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuthopAccountServiceExchangeOidcLoginCodeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AuthopAccountServiceExchangeOidcLoginCodeResponse, a, b);
    }
}
exports.AuthopAccountServiceExchangeOidcLoginCodeResponse = AuthopAccountServiceExchangeOidcLoginCodeResponse;
AuthopAccountServiceExchangeOidcLoginCodeResponse.runtime = protobuf_1.proto3;
AuthopAccountServiceExchangeOidcLoginCodeResponse.typeName = "spwn.account.v1.AuthopAccountServiceExchangeOidcLoginCodeResponse";
AuthopAccountServiceExchangeOidcLoginCodeResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "uid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "auth_time_seconds", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message spwn.account.v1.AuthopAccountServiceGetAccountStateRequest
 */
class AuthopAccountServiceGetAccountStateRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * auth-op が sub として持っている Firebase の uid
         *
         * @generated from field: string uid = 1;
         */
        this.uid = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AuthopAccountServiceGetAccountStateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuthopAccountServiceGetAccountStateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuthopAccountServiceGetAccountStateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AuthopAccountServiceGetAccountStateRequest, a, b);
    }
}
exports.AuthopAccountServiceGetAccountStateRequest = AuthopAccountServiceGetAccountStateRequest;
AuthopAccountServiceGetAccountStateRequest.runtime = protobuf_1.proto3;
AuthopAccountServiceGetAccountStateRequest.typeName = "spwn.account.v1.AuthopAccountServiceGetAccountStateRequest";
AuthopAccountServiceGetAccountStateRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "uid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.AuthopAccountServiceGetAccountStateResponse
 */
class AuthopAccountServiceGetAccountStateResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 検証済みの最新のメールアドレス。auth-op が保持しているスナップショットを上書きする
         *
         * @generated from field: string email = 1;
         */
        this.email = "";
        /**
         * 凍結されているか
         *
         * @generated from field: bool disabled = 2;
         */
        this.disabled = false;
        /**
         * ここより前に行われた認証を無効とみなす時刻 (UNIX 秒)。ログアウトで進む。
         * 一度もログアウトしていなければ 0
         *
         * @generated from field: int64 tokens_valid_after_seconds = 3;
         */
        this.tokensValidAfterSeconds = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AuthopAccountServiceGetAccountStateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuthopAccountServiceGetAccountStateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuthopAccountServiceGetAccountStateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AuthopAccountServiceGetAccountStateResponse, a, b);
    }
}
exports.AuthopAccountServiceGetAccountStateResponse = AuthopAccountServiceGetAccountStateResponse;
AuthopAccountServiceGetAccountStateResponse.runtime = protobuf_1.proto3;
AuthopAccountServiceGetAccountStateResponse.typeName = "spwn.account.v1.AuthopAccountServiceGetAccountStateResponse";
AuthopAccountServiceGetAccountStateResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "disabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "tokens_valid_after_seconds", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
//# sourceMappingURL=authop_service_pb.js.map